/**
 * Created by anthony on 6/24/14.
 */

var editSumsModel = angular.module('editSumsModel', ['familyModel']);
editSumsModel.factory('EditSumsModelFactory', function(ApplicationService, AbstractModelService, FamilyModelFactory, $q, RestService){
    var EditSumsModel = function(familyID){
        this.familyID = familyID;
        this.endpoint = "/editsums";
        this.dataProperty = "edit_sums";

    }
    EditSumsModel.prototype = new FamilyModelFactory();
    EditSumsModel.prototype.parent = FamilyModelFactory.prototype;
    EditSumsModel.prototype.put = function(id, data, instance)
    {
        return AbstractModelService.put("/api/family/" + id + "/editsums/" + id, data, instance);
    }
    EditSumsModel.prototype.resolveData = function()
    {
        let promise = $q.defer();
        AbstractModelService.get("/api/family/" + ApplicationService.getFamilyData().data[0].familyID + "/editsums")
            .then( (results) => {
            ApplicationService.getFamilyData().edit_sums = results.data[0];
            promise.resolve();
        });
        return promise.promise;
    }

    return EditSumsModel;

});

editSumsModel.service('EditSumsModelService', function(EditSumsModelFactory){
    var editSumsModel = new EditSumsModelFactory();
    return editSumsModel;
});